var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"welcome-text text-center px-4"},[_c('h1',[_vm._v(_vm._s(_vm.$t('404.not-found'))+" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('404.back-home')))])],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }